import { insertIcons } from '@lib/icon';

window.Drupal.behaviors['icon'] = {
    attach: function () {
        document.querySelectorAll<HTMLElement>('[data-icon]:not([data-icon-inserted])').forEach((iconEl) => {
            insertIcons(iconEl);
        });
    },
};
